import { MouseEvent } from 'react';
import ActionButton from './ActionButton';

type Props = {
  playlistGraphic: PlaylistGraphic;
  imageSrc?: string;
  onAddMedia: () => void;
  onDeleteMedia: (e: MouseEvent<HTMLDivElement>) => void;
  onToggleConcept: () => void;
};

export default function HoverActions({
  playlistGraphic,
  imageSrc,
  onAddMedia,
  onDeleteMedia,
  onToggleConcept,
}: Props) {
  return (
    <div className="absolute flex items-center justify-center gap-1 opacity-0 scale-95 group-hover:opacity-100 group-hover:scale-100 transition-all duration-200 ease-out">
      {!playlistGraphic.isConcept && (
        <ActionButton
          icon="plus"
          title={imageSrc ? 'Replace image' : 'Add image'}
          onClick={onAddMedia}
        />
      )}
      {imageSrc ? (
        <ActionButton title="Delete image" icon="trash" onClick={onDeleteMedia} />
      ) : (
        <ActionButton
          title={playlistGraphic.isConcept ? 'Clear image' : 'Keep previous image'}
          icon={playlistGraphic.isConcept ? 'eye' : 'eye-slash'}
          weight="fill"
          onClick={onToggleConcept}
        />
      )}
    </div>
  );
}
